/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Grid, Tooltip, Typography } from '@material-ui/core';
import { DataGrid, useGridApiContext, useGridState } from '@mui/x-data-grid';
import { Stack, Pagination, PaginationItem, Button, IconButton, MenuItem, Menu, Checkbox, FormControlLabel, Switch } from '@mui/material';
import moment from 'moment';
import { BorderColor, DeleteOutline, FilterAlt, Visibility } from '@mui/icons-material';
import { toast } from 'react-toastify';

import useStyles from './styles';
import { deleteSpecificNotification, notificationList, toggleBanner } from '../../redux/Actions/notificaton.action';
import Delete from './Delete';
import ToggleBanner from './ToggleBanner';
import noNotificationIcon from '../../assets/images/noNotifications.svg';

function CustomPagination(props) {
    const apiRef = useGridApiContext();
    const [state] = useGridState(apiRef);

    const classes = useStyles();

    useEffect(() => {
        apiRef.current.setPage(props.page);
    }, [props.page, apiRef]);

    return (
        <div className={classes.customPagination}>
            {state.pagination.rowCount ? (
                <div>
                    <span className={classes.showPaginationDesc}>
                        Showing {state.pagination.page * 10 + 1} to {Math.min((state.pagination.page + 1) * 10, state.pagination.rowCount)} of {state.pagination.rowCount} entries
                    </span>
                    <Pagination
                        className={classes.root}
                        color="primary"
                        count={state.pagination.pageCount}
                        page={state.pagination.page + 1}
                        onChange={(event, value) => apiRef.current.setPage(value - 1)}
                        ariant="outlined"
                        shape="rounded"
                        hideNextButton={false}
                        variant="outlined"
                        renderItem={(item) => (
                            <PaginationItem {...item} className={classes.pageItem} variant="text" />
                        )}
                    />
                </div>
            ) : ''}
        </div>
    );
}

const ReleaseNotificationList = (props) => {
    const classes = useStyles();
    const resultsPerPage = 10;

    const [scheduleAnchorEl, setMenuAnchorEl] = useState(null);

    const open = Boolean(scheduleAnchorEl);
    const [pagination, setPagination] = useState(0);
    const [notifications, setNotifications] = useState({ list: [], count: 0 });
    const [deleteNotification, setDeleteNotificationModal] = useState({ show: false, id: '' });
    const [toggleBannerModal, setToggleBannerModal] = useState({ show: false, id: '' , bannerEnabled: false });
    const [loading, setLoading] = useState(true);
    const [selectedMenus, setSelectedMenus] = useState({ suva: false, knowbler: false, searchUnify: false });
    const [emptyNotificationPoupup, setEmptyNotificationPopup] = useState(false);
    const [hideCreateButton, setHideCreateButton] = useState(false);
    const { feature6Url, notificationAppId, notificationToken } = useSelector((state) => state.constants.settings);

    const handleChange = (event) => {
        setSelectedMenus({
            ...selectedMenus,
            [event.target.name]: event.target.checked
        });
    };

    const handleCloseMenu = () => setMenuAnchorEl(null);

    const statusComp = (params) => {
        const publishAt = moment(params.row.publishAt);

        let statusHeading;

        if (moment().isBefore(publishAt) && params.row.status === 1) statusHeading = 'Scheduled';
        else if (moment().isAfter(publishAt) && params.row.status === 1) statusHeading = 'Published';
        else statusHeading = 'Draft';

        return (
            <div className={`${classes.statusContainer} 
        ${statusHeading === 'Published' ? classes.published : ''}
        ${statusHeading === 'Scheduled' ? classes.scheduled : ''}
        ${statusHeading === 'Draft' ? classes.draft : ''}
        `}>
                <div className={classes.statusHeading}>
                    <div>{statusHeading}</div>
                </div>
                <div className={classes.statusDate}>
                    <div>({moment(params.row.publishAt).format('YYYY-MM-DD hh:mm:ss')})</div>
                </div>
            </div>
        );
    };

    const handleMenuPopupClick = (event) => {
        setMenuAnchorEl(event.currentTarget);
    };

    const columns = [
        {
            field: 'title',
            headerName: 'Title',
            sortable: false,
            flex: 1,
            minWidth: 100,
            renderCell: (params) =>
                <div className={classes.row}>
                    <Tooltip
                        placement='top-start'
                        title={params.row.title}
                    >
                        <span className={classes.overflowText}>
                            {params.row.title}
                        </span>
                    </Tooltip>
                </div>
        },
        {
            field: 'description',
            headerName: 'Description',
            sortable: false,
            flex: 1,
            minWidth: 100,
            renderCell: (params) =>
                <div className={classes.row}>
                    <Tooltip
                        placement='top-start'
                        title={params.row.description}
                    >
                        <span className={classes.overflowText}>
                            {params.row.description}
                        </span>
                    </Tooltip>
                </div>
        },
        {
            field: 'modified',
            headerName: 'Last modified by',
            sortable: false,
            flex: 1.5,
            minWidth: 100,
            renderCell: (params) =>
                <div className={classes.row}>
                    <p>{params.row.createdBy?.userEmail || ''}</p>
                </div>
        },
        {
            field: 'product',
            headerName: 'Product',
            sortable: false,
            flex: 1,
            minWidth: 100,
            renderCell: (params) =>
                <div className={classes.row}>
                    <p>{params.row.appId === 1 ? 'SearchUnify' : 'Knowbler'}</p>
                </div>,
            // renderHeader: () => (
            //     <SearchToolBar selectedMenus={selectedMenus} setSelectedMenus={setSelectedMenus} listNotifications={listNotifications} />
            // ),
            renderHeader: () => (
                <div style={{ flexWrap: 'nowrap !important'}} className={classes.header}>
                    Product
                    <IconButton
                        aria-haspopup="true"
                        color="inherit"

                        onClick={handleMenuPopupClick}

                    >
                        <FilterAlt />
                    </IconButton>
                    <Menu
                        id="fade-menu"
                        open={open}
                        className={classes.menuList}
                        anchorEl={scheduleAnchorEl}
                        onClose={handleCloseMenu}
                        MenuListProps={{
                            'aria-labelledby': 'fade-button',
                        }}
                    >
                        <MenuItem dense className={classes.menuItems}>
                            <FormControlLabel onChange={handleChange} label="SearchUnify" control={<Checkbox name='searchUnify' checked={selectedMenus.searchUnify} />} />
                        </MenuItem>
                        <MenuItem dense className={classes.menuItems}>
                            <FormControlLabel onChange={handleChange} label="Knowbler" control={<Checkbox name='knowbler' checked={selectedMenus.knowbler} />} />
                        </MenuItem>
                    </Menu>
                </div>
            ),

        },
        {
            field: 'status',
            headerName: 'Status',
            sortable: false,
            flex: 1,
            minWidth: 200,
            renderCell: statusComp
        },
        {
            field: 'actions',
            headerName: 'Actions',
            sortable: false,
            flex: 1,
            width: 110,
            renderCell: (params) =>
                <div className={classes.actionGroup}>
                    <IconButton size="small" onClick={() => window.open(`${feature6Url}/${params.row.appId === 2 ? 'knowbler': ''}`)}>
                        <Visibility fontSize="small" />
                    </IconButton>

                    <IconButton size='small' onClick={() => setDeleteNotificationModal({ show: true, id: params.row._id })}>
                        <DeleteOutline fontSize="small" />
                    </IconButton>
                    {
                        moment().isBefore(moment(params.row.publishAt)) || params.row.status === 0 ?
                            <IconButton size='small' onClick={() => props.history.push(`/app/notifications/${params.row._id}`)}>
                                <BorderColor fontSize="small" />
                            </IconButton> : null
                    }
                    {
                        (moment().isAfter(moment(params.row.publishAt)) && params.row.status === 1 && params.row.appId === 1) ?
                            <Switch
                                checked={Boolean(params.row.bannerEnabled)}
                                onChange={() => toggleNotificationBanner(params.row._id, params.row.bannerEnabled)}
                                className={classes.customToggleSwitch}
                            /> : null
                    }
                </div>
        }
    ];

    const removeNotification = () => {
        const payload = {
            approval: true,
            _id: deleteNotification.id,
        };

        deleteSpecificNotification(payload, notificationToken).then(() => {
            toast.success('Notification deleted successfully');
            setDeleteNotificationModal({ show: false, id: '' });

            listNotifications(0);
        });
    };

    const toggleNotificationBanner = (id, bannerEnabled ) => {
        setToggleBannerModal({ show: true, id, bannerEnabled });
    };

    const confirmToggleBanner = () => {
        toggleBanner(toggleBannerModal.id, toggleBannerModal.bannerEnabled, notificationToken).then(() => {
            toast.success(!toggleBannerModal.bannerEnabled ? 'Banner enabled successfully' : 'Banner disabled successfully');
            setToggleBannerModal({ show: false, id: '' , bannerEnabled: toggleBannerModal.bannerEnabled });
            listNotifications(pagination);
        }).catch(() => {
            toast.error('Failed to toggle banner');
            setToggleBannerModal({ show: false, id: '' , bannerEnabled: toggleBannerModal.bannerEnabled });
        });
    };

    const listNotifications = (pageNo, appId = null) => {
        setLoading(true);
        const query = {
            pageNumber: pageNo + 1,
            resultsPerPage
        };

        if (appId) {
            query.appId = appId;
        }

        notificationList(query, notificationToken).then(res => {
            const notifications = res.data;
            setNotifications({ list: notifications, count: res.total });
            setLoading(false);

            const filterApplied = Object.values(selectedMenus).filter(item => item);

            setHideCreateButton(
                notifications.length !== 0 ||
                (filterApplied.length !== 0 && notifications.length === 0)
            );

            setEmptyNotificationPopup(notifications.length === 0 && filterApplied.length === 0);
        });
    };

    useEffect(() => {
        const appId = [];

        if (selectedMenus.searchUnify) appId.push(notificationAppId.searchUnify);
        if (selectedMenus.knowbler) appId.push(notificationAppId.knowbler);
        if (selectedMenus.suva) appId.push(notificationAppId.suva);

        listNotifications(appId.length ? 0 : pagination, appId);
    }, [selectedMenus, pagination]);

    return (
        <div className={classes.notificationContainer}>
            <Grid container justifyContent='space-between'>
                <Grid item xs={10}>
                    <Typography variant='h1' className={classes.heading}>
                        Notifications
                    </Typography>
                </Grid>

                {
                    !loading && hideCreateButton ?
                        <Button
                            variant="outlined"
                            onClick={() => props.history.push('/app/notifications/create')}
                            className={classes.notificationButton}
                        >
                            Add Notification
                        </Button> : null
                }
            </Grid>

            {
                !loading && emptyNotificationPoupup ?
                    <div className={classes.noNotificationContainer}>
                        <img src={noNotificationIcon} width={500} alt="no-notification" />
                        <p>No notifications have been added yet</p>
                        <Button
                            variant="outlined"
                            onClick={() => props.history.push('/app/notifications/create')}
                            className={classes.notificationButton}
                        >
                            Add Notification
                        </Button>
                    </div> : null

            }

            {
                !emptyNotificationPoupup ?
                    <Stack>
                        <DataGrid
                            disableRowSelectionOnClick
                            className={classes.table}
                            rows={notifications.list}
                            columns={columns}
                            sx={{
                                '& .MuiDataGrid-row': {
                                    paddingBottom: '16px !important',
                                },
                                '.MuiDataGrid-selectedRowCount': {
                                    visibility: 'hidden'
                                }
                            }}
                            pageSize={resultsPerPage}
                            getRowId={(row) => row._id}
                            autoHeight
                            pagination
                            components={{
                                Pagination: CustomPagination,
                                NoRowsOverlay: () => (
                                    <Stack
                                        height="100%"
                                        alignItems="center"
                                        justifyContent="center"
                                        className={classes.emptyDataText}
                                    >
                                        No Data To Show
                                    </Stack>
                                ),
                                NoResultsOverlay: () => (
                                    <Stack
                                        height="100%"
                                        alignItems="center"
                                        justifyContent="center"
                                        className={classes.emptyDataText}
                                    >
                                        No Data To Show
                                    </Stack>
                                )

                            }}
                            componentsProps={{
                                pagination: {
                                    page: pagination,
                                }
                            }}
                            filterMode="server"
                            paginationMode="server"
                            onPageChange={(newPage) => setPagination(newPage)}
                            disableColumnMenu
                            hideFooter={notifications.count <= resultsPerPage}
                            rowCount={notifications.count}
                            loading={loading}
                            disableSelectionOnClick
                        />
                    </Stack>
                    :
                    null
            }

            <Delete
                open={deleteNotification.show}
                handleClose={() => setDeleteNotificationModal({ show: false, id: '' })}
                deleteNotification={removeNotification}
            />

            <ToggleBanner
                open={toggleBannerModal.show}
                bannerEnabled={toggleBannerModal.bannerEnabled || false}
                handleClose={() => setToggleBannerModal({ show: false, id: '' })}
                toggleNotificationBanner={confirmToggleBanner}
            />
        </div>
    );
};

export default ReleaseNotificationList;
